function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "ico / 24 / actions / search"
}, React.createElement("path", {
  id: "Icon color",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5637 15.6139L21.5637 19.6187C21.7424 19.8174 21.7335 20.1215 21.5437 20.3095L20.8437 21.0104C20.7498 21.1051 20.622 21.1584 20.4887 21.1584C20.3554 21.1584 20.2276 21.1051 20.1337 21.0104L16.1337 17.0055C16.0231 16.8947 15.9227 16.7741 15.8337 16.6451L15.0837 15.6439C13.8428 16.636 12.3018 17.1762 10.7137 17.1758C7.44133 17.1871 4.59774 14.927 3.86645 11.7336C3.13516 8.54005 4.71132 5.26543 7.66182 3.84836C10.6123 2.43129 14.1497 3.24996 16.1797 5.8197C18.2097 8.38943 18.1906 12.0244 16.1337 14.5726L17.1337 15.2635C17.2899 15.3635 17.4341 15.4811 17.5637 15.6139ZM5.71372 10.1673C5.71372 12.9321 7.95229 15.1733 10.7137 15.1733C12.0398 15.1733 13.3116 14.6459 14.2493 13.7071C15.1869 12.7683 15.7137 11.495 15.7137 10.1673C15.7137 7.40256 13.4751 5.16129 10.7137 5.16129C7.95229 5.16129 5.71372 7.40256 5.71372 10.1673Z",
  fill: "#007A72"
}));

var SvgMagnifier = function SvgMagnifier(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMagnifier, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/magnifier.873e52ea.svg";
export { ForwardRef as ReactComponent };